import { VehicleNeeds } from "../../../models";

export const initialVehicleNeedsState: VehicleNeeds = {
  roundTripCommuteMiles: 0,
  commuteDaysPerWeek: 0,
  otherMilesPerWeek: 0,
  milesDrivenPerYear: 10000,
  plannedLengthOfOwnership: 5
};
